// Change website animations
const animation = {
  // make it false to switch off fade-up animation
  animate: true,
  // animation playing duration
  duration: 750,
  // if false, animation plays everytime element comes on screen
  once: true,
};
// Change your display name on tha landing display
const header = {
  name: "Dustin Myers",
};
const background = {
  // Options: Snow or Particle
  type: "Particle",
};
// Write a para about yourself here
// To update your image, go to './styles/images.css'
const section2title = "How it started";
const about = {
  paragraph:
    "I was sitting in my office getting ready to gather data from several different spreadsheets to fill out my daily reports. I thought to myself 'If only there was a way I could automate this process.' A few weekends of reading 'Automate the boring stuff with python' later I had written a script to do just that. With a click of a button two hours worth of work done. Just.. Like.. That. I thought 'Wow that was awesome. What else am I capable of.' And so my journey began.",
};
// Edit your skill and the percentage you know about it
// To Add a skill, copy any one below and paste it after the last comma
const skillsBar = [
  {
    name: "React",
    faClass: "fab fa-react",
  },
  {
    name: "HTML5",
    faClass: "fab fa-html5",
  },
  {
    name: "CSS3",
    faClass: "fab fa-css3",
  },
  {
    name: "Javascript",
    faClass: "fab fa-js",
  },
  {
    name: "SASS",
    faClass: "fab fa-sass",
  },
  {
    name: "Node",
    faClass: "fab fa-node",
  },
  {
    name: "Python",
    faClass: "fab fa-python",
  },
  {
    name: "Database",
    faClass: "fas fa-database",
  },
  {
    name: "Docker",
    faClass: "fab fa-docker",
  },
  {
    name: "NPM",
    faClass: "fab fa-npm",
  },
  {
    name: "Heroku",
    faClass: "fas fa-h-square",
  },
  {
    name: "Linux",
    faClass: "fab fa-linux",
  },
];
// Edit your projects, its name, your skills used to make it, and the url.
// You can omit freely anything if you dont have it
// To Add a Project, copy any one below and paste it after the last comma and increment the id's project number
const section3Title = "Projects";
const projects = [
  {
    // Add image in './styles/images.css' in #project1
    id: "project1",
    name: "Restaurant Reservations",
    skills: ["PERN Stack"],
    url: "https://restaurants-reservations.vercel.app/",
    github: "https://github.com/dstnmyrs99/restaurant-reservation-front"
  },
  {
    // Add image in './styles/images.css' in #project2
    id: "project2",
    name: "Custom Home Page",
    skills: ["React, Bootstrap, Node, Express"],
    url: "https://dustinshomepage.netlify.app/",
    github: "https://github.com/dstnmyrs99/homepage"
  },
  {
    // Add image in './styles/images.css' in #project3
    id: "project3",
    name: "WeLoveMovies",
    skills: ["PERN Stack"],
    url: "https://we-love-movies.netlify.app/",
    github: "https://github.com/dstnmyrs99/WeLoveMovies-frontend"
  },
  {
    // Add image in './styles/images.css' in #project4
    id: "project4",
    name: "Dino Bros",
    skills: ["PERN Stack, Phaser 5"],
    url: "https://dinoplatformer.herokuapp.com/",
    github: "https://github.com/dstnmyrs99/platformer"
  },
  {
    // Add image in './styles/images.css' in #project5
    id: "project5",
    name: "Card Game",
    skills: ["HTML, CSS, JS, JQuery"],
    url: "https://dstnmyrs99.github.io/cardgame/",
    github: "https://github.com/dstnmyrs99/cardgame"
  },
  {
    // Add image in './styles/images.css' in #project6
    id: "project6",
    name: "Chat Box",
    skills: ["HTML, CSS, JS, JQuery, Socket.IO"],
    url: "https://dustychatbox.herokuapp.com/",
    github: "https://github.com/dstnmyrs99/chatbox"
  },
];
// Contact form text, and Jotforms link
// To get your own jotform link, go to https://www.jotform.com/
// If you hacve the link already, paste it in the contactUrl below
const section5Title = "Get in Touch";
const contact = {
  pitch:"Connect with me on LinkedIn, visit my GitHub, download my resume, or send me a message.",
  copyright: "Dustin Myers",
  contactUrl: "",
};
// Paste your respective social media links. You can omit any if you dont have it
// Upload your resume in your drive, get the shaareable link and paste it in the resume section
const social = {
  github: "https://github.com/dstnmyrs99",
  linkedin: "https://www.linkedin.com/in/dustin-myers-2021/",
  resume: "/resume.pdf",
};
// Dont change anything here
export {
  animation,
  header,
  background,
  about,
  skillsBar,
  projects,
  contact,
  social,
  section2title,
  section3Title,
  section5Title,
};
